import { Col, Image, Layout, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";
import { TiArrowSortedDown } from "react-icons/ti";
import { ImageUrl } from "../../helpers/Functions";
import "./faq.css";

const faqs = [
    {
        index: 1,
        text: "What types of training programs do you offer? ",
        innerText: "We offer a range of online training programs for the early care and education industry, including foundational courses, specialized skill development, and professional development opportunities. Our training covers topics supporting every service area. Courses cover everything from board development to early childhood development, classroom management, early literacy, facilities, health and safety, and more.",
    },
    {
        index: 2,
        text: "How do I enroll in a course?",
        innerText: "Student registration is free and easy! On the home page, click the Join Us Free button and follow the instructions to register. You must create an account to track your progress and access course materials.",
    },
    {
        index: 3,
        text: "Can I take the courses at my own pace?",
        innerText: "Yes, most of our online training programs are self-paced. You can start and finish the courses according to your schedule or as your organization outlines, allowing you to balance your professional responsibilities with your learning.",
    },
    {
        index: 4,
        text: "Will I receive a certificate after completing a course?",
        innerText: "Yes, upon completing a course, you will receive a certificate of completion that you can use for professional development or to meet licensing requirements (where applicable).",
    },
    {
        index: 5,
        text: "What technology do I need to participate in online training?",
        innerText: "Our courses are compatible with most devices, including desktops, laptops, tablets, and smartphones. You only need an internet connection and a modern web browser (Chrome, Firefox, Safari, etc.) to access the training materials. If it's an in-person virtual training, no worries; we can work with any of the meeting platforms, including but not limited to Zoom, Webex, Microsoft Teams, or Google Meet.",
    },
    {
        index: 6,
        text: "Are your courses available in languages other than English?",
        innerText: "Currently, most of our courses are offered in English. Some translation features are built-in, and we are working on expanding our offerings. We hope to provide multilingual training options shortly. Please check the individual course descriptions for language availability.",
    },
    {
        index: 7,
        text: "Are the training programs accredited? ",
        innerText: "No, not at this time. However, we are working on accredited courses that will fulfill continuing education requirements. Please check the course details or contact us for more information on specific accreditation or certification.",
    },
    {
        index: 8,
        text: "Can I get a refund if I’m unsatisfied with a course I've taken? ",
        innerText: "We offer a satisfaction guarantee for our training programs. If you're unsatisfied with a course, please get in touch with us within a specified time frame (typically within 14 days of purchase) for a refund or course credit. Please take a look at our refund policy for more details.",
    },
    {
        index: 9,
        text: "How can I contact customer support if I have questions or issues?",
        innerText: "You can reach our customer support team by email at [support@wrightcoacademy.com] or by calling 877-701-2899. Our team can assist you with any enrollment, technical, or course-related questions.",
    },
    {
        index: 10,
        text: "Do you offer group or organizational training packages? ",
        innerText: "Yes! We offer customized group training solutions for organizations, and we have enterprise options. If you're interested in training for a team or organization, please get in touch with us to discuss your needs and get a quote. Call us at 877-701-2899.",
    },
    {
        index: 11,
        text: "How are your training programs delivered? ",
        innerText: "In addition to offering virtual and on-demand training, we offer in-person training  (at a location of your choice). We can also offer a customized hybrid model combining any two of the former. For in-person training, you can reach our customer training support team by email at training@wrightcoacademy.com or by calling us at 877-701-2899.",
    },
];


const FAQ = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout className="faq-page-layout">
      <Row className="blueBackground-old faqbnr faq-hero">
        <div className="faq-hero-panel">
          <Typography.Text className="faq-hero-kicker">Support Center</Typography.Text>
          <Typography.Title className="fontFamily1 faq-hero-title">
            FAQ
          </Typography.Title>
          <Typography.Paragraph className="fontFamily1 faq-hero-subtitle">
            Quick answers to the most common questions about training,
            enrollment, certifications, and support.
          </Typography.Paragraph>
        </div>
      </Row>

      <Row className="whiteBackground faq-main-section">
        <Col xs={24} md={20} lg={22} xl={20}>
          <div className="faq-content-shell">
            <div className="faq-list-col">
              <Rows />
            </div>
            <div className="faq-image-col">
              <div className="faq-image-wrap">
                <Image
                  alt={"FAQ illustration"}
                  preview={false}
                  src={ImageUrl("faq.jpg")}
                  className="faq-image"
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default FAQ


const Rows = () => {
  const CustomRow = ({ faq }) => {
    const [expanded, setExpanded] = useState(false);

    const toggleExpand = () => {
      setExpanded(!expanded);
    };

    return (
      <div className="faq-item">
        <div onClick={toggleExpand} className="faq-item-header">
          <h4 className="faq-item-title">{faq.text}</h4>

          <div className="faq-item-icon-wrap">
            <TiArrowSortedDown
              className={`faq-item-icon ${expanded ? "rotate-180" : ""}`}
            />
          </div>
        </div>

        <div
          style={{
            maxHeight: expanded ? "500px" : "0px",
            opacity: expanded ? 1 : 0,
            paddingTop: expanded ? "16px" : "0px",
            paddingBottom: expanded ? "16px" : "0px",
          }}
          className="faq-item-content"
        >
          <p className="faq-item-text">{faq.innerText}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="faq-accordion-list">
      {faqs?.map((faq, index) => (
        <CustomRow key={index} faq={faq} />
      ))}
    </div>
  );
};